import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const URL = `${process.env.REACT_APP_BACKEND_URL}/api/admin/fabrics/room-favorites`;

/* Admin's favourite AI room types — shown first and pre-selected in Regenerate dialogs */
export const useRoomFavorites = (token) => {
  const [favorites, setFavorites] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!token) return;
    axios.get(URL, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setFavorites(data.rooms || []))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [token]);

  const toggle = useCallback(async (room) => {
    const next = favorites.includes(room) ? favorites.filter(r => r !== room) : [...favorites, room];
    setFavorites(next);
    try {
      const { data } = await axios.put(URL, { rooms: next }, { headers: { Authorization: `Bearer ${token}` } });
      setFavorites(data.rooms);
    } catch { setFavorites(favorites); }
  }, [favorites, token]);

  return { favorites, loaded, toggle };
};
